import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { CONTACT, LINKS } from '../data/site';
export function ClosingCta() {
  return <section className="bg-fred text-white" aria-labelledby="cta-heading" data-id="element-59" data-mp="106ixe501bztz">
      <div className="mx-auto flex max-w-[1240px] flex-col gap-8 px-5 py-14 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:py-16" data-id="element-60" data-mp="l8gttut07ecq">
        <div data-id="element-61" data-mp="q8up0c9iattc">
          <h2 id="cta-heading" className="font-display text-[42px] font-bold uppercase leading-none sm:text-[56px]" data-id="element-62" data-mp="q8l8dfacpz0b">
            What are you building?
          </h2>
          <p className="mt-4 max-w-[54ch] text-[16px] leading-relaxed text-white/90 sm:text-[17px]" data-id="element-63" data-mp="146janmbee4zg">
            Whether you need help picking the right tool, want time on the wheel with an instructor, or have a
            panel that has to be made from scratch — talk to the shop.
          </p>
        </div>
        <div className="flex flex-wrap gap-3" data-id="element-64" data-mp="21lnethiql86r">
          <a href={CONTACT.phoneHref} className="inline-flex min-h-[52px] items-center gap-2 bg-charcoal px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-black" data-id="element-65" data-mp="21ni0wz5qv6cf">
            <PhoneIcon aria-hidden="true" className="h-4 w-4" data-id="element-66" data-mp="1ttlxg2byrvhf" />
            {CONTACT.phoneLabel}
          </a>
          <a href={LINKS.contact} className="inline-flex min-h-[52px] items-center border border-white px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-white hover:text-fred" data-id="element-67" data-mp="1p241xtspmn3u">
            Contact the Shop
          </a>
        </div>
      </div>
    </section>;
}